import React from "react";
import clsx from "clsx";
import SectionRows from "../../shared/SectionRows";
import { formatAmount } from "../../shared/helpers/formatters";
import { IS_ORDER } from "../../shared/helpers/constants";
import "../../afs-walkthrough.css";
import WComponent from "../../../../../common/WComponent";

const fmt = formatAmount;

class ISView extends WComponent {
	state = { expanded: new Set() };

	toggle = name => {
		this.setState(prev => { const n = new Set(prev.expanded); n.has(name) ? n.delete(name) : n.add(name); return { expanded: n }; });
	};

	render() {
	let { incomeStatement, currentYear, priorYear, priorPriorYear, showComparatives, show2022, hasTransactions, onDrillAccount, onNavigateToLeadSheet, onMoveAccount, onSortSection, onRenameAccount, accountCaptions, sectionSortOrder } = this.props;
	let { expanded } = this.state;
	const toggle = this.toggle;

	const sections = incomeStatement.sections || [];

	const sorted = [...sections].sort((a, b) => {
		const ai = IS_ORDER.indexOf(a.category);
		const bi = IS_ORDER.indexOf(b.category);
		if (ai === -1 && bi === -1) return 0;
		if (ai === -1) return 1;
		if (bi === -1) return -1;
		return ai - bi;
	});

	const netIncome = incomeStatement.netIncome || {};
	const isPositive = (netIncome.prior || 0) >= 0;

	const sharedProps = { expanded, onToggle: toggle, showComparatives, show2022, hasTransactions, onDrillAccount, onNavigateToLeadSheet, onMoveAccount, onSortSection, onRenameAccount, accountCaptions, sectionSortOrder };

	return (
		<table className="afs-fs-table">
			<thead>
				<tr>
					<th className="afs-fs-table__th-name" />
					<th className="afs-fs-table__th-wp">WP</th>
					<th className="afs-fs-table__th-amt">{currentYear}</th>
					{showComparatives && <th className="afs-fs-table__th-amt">{priorYear}</th>}
					{show2022 && <th className="afs-fs-table__th-amt afs-fs-table__th-amt--faded">{priorPriorYear}</th>}
				</tr>
			</thead>
			<tbody>
				{sorted.map(s => <SectionRows key={s.name} section={s} {...sharedProps} />)}
				<tr className="afs-fs-table__grand-total-row">
					<td className={clsx(isPositive ? "afs-fs-table__net-income-name--positive" : "afs-fs-table__net-income-name--negative")}>Net Income (Loss)</td>
					<td />
					<td className={clsx(isPositive ? "afs-fs-table__net-income-amt--positive" : "afs-fs-table__net-income-amt--negative")}>{fmt(netIncome.current)}</td>
					{showComparatives && <td className={clsx(isPositive ? "afs-fs-table__net-income-amt--positive" : "afs-fs-table__net-income-amt--negative")}>{fmt(netIncome.prior)}</td>}
					{show2022 && <td className="afs-fs-table__grand-total-amt afs-fs-table__grand-total-amt--faded">{fmt(netIncome.priorPrior)}</td>}
				</tr>
			</tbody>
		</table>
	);
	}
}

export default ISView;
